// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"29639bb1","111":"d0a50006","170":"8aa3204c","194":"cd0b4f8b","461":"2e797a1e"}[chunkId] + ".chunk.css";
};